import Link from 'next/link'
import React from 'react'
import { LogoGray } from '../icons/LogoGray'

export function Footer() {
  return (
    <footer className='border-t gotham border-lighter-gray'>
      <div className='max-w-md px-6 py-12 mx-auto overflow-hidden sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8 md:flex md:items-start md:justify-between'>
        <div className='flex flex-col justify-between flex-shrink-0 sm:items-center sm:flex-row md:block'>
          <Link href='/'>
            <a>
              <LogoGray className='cursor-pointer' />
            </a>
          </Link>
          <div className='mt-4 text-sm font-medium text-left text-gray opacity-40'>
            <p>© 2021 GraphCDN, Inc.</p>
            <p>All rights reserved.</p>
          </div>
        </div>
        <nav className='flex flex-wrap mt-10 sm:mt-0' aria-label='Footer'>
          <FooterItem href='/features'>Features</FooterItem>
          <FooterItem href='/pricing'>Pricing</FooterItem>
          <FooterItem href='/blog'>Blog</FooterItem>
          <FooterItem href='/docs'>Docs</FooterItem>
          <FooterItem href='/about'>About</FooterItem>
          <FooterItem
            href='mailto:support@graphcdn.io'
            onClick={(evt) => {
              // If Intercom is loaded, send them there
              // otherwise send them to the email link below
              // @ts-ignore
              if (window.Intercom?.booted) {
                evt.preventDefault()
                // @ts-ignore
                window.Intercom('show')
              }
            }}
          >
            Support
          </FooterItem>
          <FooterItem href='https://status.graphcdn.io'>
            <span className='flex items-center opacity-60 hover:opacity-80'>
              Status
              <span className='inline-block w-2 h-2 ml-2 rounded-full bg-green'></span>
            </span>
          </FooterItem>
        </nav>
      </div>
    </footer>
  )
}

const FooterItem = ({ href, ...rest }) => (
  <div className='py-2 pr-4 md:px-5'>
    <Link href={href}>
      <a
        className='text-lg font-medium text-gray gotham opacity-60 hover:opacity-80'
        {...rest}
      ></a>
    </Link>
  </div>
)
